import team from './team';
import services from './services';
import activities from './activities';
import events from './events';
import projects from './projects';
import accommodations from './accommodations';
import { positions } from './career';
import destinations from './destinations';
import tours from './tours';
import blogs from './blogs';
import products from './products';



const navbar = [
    {
        id: 1,
        mainLink : {link: '/', title: 'home'},
        subLink: [],
    },
    {
        id: 2,
        mainLink : {link: '#', title: 'about'},
        subLink: [
            {id: 1, link: '/About-us', title: 'about us'},
            {id: 2, link: '/Team', title: 'team'},
            {id: 3, link: '/Team/TeamSingle', title: 'team single', state: team[0]},
            {id: 4, link: '/Testimonials', title: 'testimonials'},
            {id: 5, link: '/Faqs', title: 'faqs'},
        ],
    },
    {
        id: 3,
        mainLink: { title: "Pages", link: "#" },
        subLink: [
            { id: 1, link: "/Gallery", title: "Gallery"  },
            {
                id: 2,
                title: "Service",
                children: [
                    { id: 1, link: "/Services", title: "Services" },
                    { id: 2, link: "/Services/Service-Single", title: "Service Single",  state: services[0] },
                ],
            },
            {
                id: 3,
                title: "Activity",
                children: [
                    { id: 1, link: "/Activities", title: "Activities" },
                    { id: 2, link: "/Activities/Activity-Single", title: "Activity Single",  state:activities[0] },
                ],
            },
            {
                id: 4,
                title: "Event",
                children: [
                    { id: 1, link: "/Events", title: "Events" },
                    { id: 2, link: "/Events/Event-Single", title: "Event Single",  state: events[0] },
                ],
            },
            {
                id: 5,
                title: "Project",
                children: [
                    { id: 1, link: "/Projects", title: "Projects" },
                    { id: 2, link: "/Projects/Project-Single", title: "Project Single",  state: projects[0] },
                ],
            },
            {
                id: 6,
                title: "Accommodation",
                children: [
                    { id: 1, link: "/Accommodations", title: "Accommodations" },
                    { id: 2, link: "/Accommodations/Accommodation-Single", title: "Accommodation Single",  state: accommodations[0] },
                ],
            },
            {
                id: 7,
                title: "Career",
                children: [
                    { id: 1, link: "/Careers", title: "Careers" },
                    { id: 2, link: "/Careers/Position-Single", title: "Career Single",  state: positions[0] },
                    { id: 3, link: "/Career-Form", title: "Career Form" },
                ],
            },
            { id: 8, link: "/Pricing", title: "Pricing" },
            { id: 9, link: "/Booking", title: "Booking" },
            { id: 10, link: "/Partners", title: "Partners" },
        ],
    },
    {
        id: 4,
        mainLink : {link: '#', title: 'Destination'},
        subLink: [
            { id: 1, link: "/Destinations", title: "Destinations" },
            { id: 2, link: "/Destinations/Destination-Single", title: "Destination Single",  state: destinations[0] },
        ],
    },
    {
        id: 5,
        mainLink : {link: '#', title: 'Tour'},
        subLink: [
            { id: 1, link: "/Tours", title: "Tours" },
            { id: 2, link: "/Tours/Tour-Single", title: "Tour Single",  state: tours[0] },
        ],
    },
    {
        id: 6,
        mainLink : {link: '#', title: 'blog'},
        subLink: [
            {id: 1, link: '/Blog-grid', title: 'blog grid'},
            {id: 2, link: '/Blog-list', title: 'blog list'},
            {id: 3, link: '/Blogs/Blog-Single', title: 'blog single', state: blogs[0]},
        ],
    },
    {
        id: 7,
        mainLink : {link: '#', title: 'shop'},
        subLink: [
            {id: 1, link: '/Shop-grid', title: 'shop grid'},
            {id: 2, link: '/Shop-list', title: 'shop list'},
            {id: 3, link: '/Shop/Product-Single', title: 'product single', state: products[0]},
            {id: 4, link: '/Wishlist', title: 'wishlist'},
            {id: 5, link: '/Cart', title: 'cart'},
            {id: 6, link: '/Checkout', title: 'checkout'},
            {id: 7, link: '/OrderConfirmation', title: 'Order Confirmation'},
            {id: 8, link: '/Login', title: 'login'},
            {id: 9, link: '/Register', title: 'register'},
            {id: 10, link: '/Forgot-pwd', title: 'forgot Password'},
        ],
    },
    {
        id: 8,
        mainLink : {link: '/Contact-us', title: 'contact'},
        subLink: [],
    },
];

export default navbar;